import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  main: {
    width: '90%',
    alignItems: 'flex-end',
    borderWidth: 1,
    borderRadius: 8,
    borderColor: '#dbdbdb',
    marginTop: 26,
    marginBottom: 20
  },
  titleContainer: {
    position: 'absolute',
    backgroundColor: '#ffffff',
    width: '100%',
    flexDirection: 'row',
    left: 0,
    top: -18
  },
  text: { fontSize: 8, lineHeight: 1.6, color: 'black' },
  mainDiv: {
    width: '100%',
    padding: 8,
    borderStyle: 'solid',
    borderColor: '#dbdbdb'
  },
  subtitle: {
    fontSize: 10,
    color: 'black'
  }
})

export default styles
